import { useDispatch, useSelector } from "react-redux";

import type { BaseActivatedPanelProps } from "app/pages/sales-intelligence/common-components/table-actions-panel";
import { selectActiveLeadsType, selectActiveSearchResultsDto } from "app/pages/sales-intelligence/modules/leads-search";
import { useListParams } from "app/pages/sales-intelligence/modules/lists/context/ListParamsContext";
import { exportTopNLeadsToDynamicsThunk } from "app/pages/sales-intelligence/pages/opportunity-list/store/effects";
import {
    exportDomainsToDynamicsThunk
} from "app/pages/sales-intelligence/sub-modules/management/store/effects/dynamics/domainExport";
import {
    selectExportingToDynamics
} from "app/pages/sales-intelligence/sub-modules/management/store/selectors/dynamics/exportSelectors";

import CrmExportPanelContainer from "./CrmExportPanelContainer";

const DynamicsExportPanelContainer = (props: BaseActivatedPanelProps) => {
    const dispatch = useDispatch();

    const exportIsInProgress = useSelector(selectExportingToDynamics);
    const activeLeadsType = useSelector(selectActiveLeadsType);
    const searchResultsDto = useSelector(selectActiveSearchResultsDto);

    const listParams = useListParams();

    const handleExportNDomains = (domainsCount: number, countries: readonly number[]): void => {
        void dispatch(
            exportTopNLeadsToDynamicsThunk({
                domainsCount,
                countries,
                leadsType: activeLeadsType,
                dto: searchResultsDto,
                listParams,
            }),
        );
    };

    const handleExportDomains = (domains: readonly string[], countries: readonly number[]): void => {
        void dispatch(exportDomainsToDynamicsThunk(domains, countries, activeLeadsType, listParams?.id));
    };

    return (
        <CrmExportPanelContainer
            integration="dynamics"
            isExportInProgress={exportIsInProgress}
            label={{ key: "si.multi_selector.dynamics.title" }}
            onDeactivate={props.onDeactivate}
            onExportNDomains={handleExportNDomains}
            onExportDomains={handleExportDomains}
        />
    );
};

export default DynamicsExportPanelContainer;
